export default "__VITE_ASSET__CnPkIjRI__"